// value.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ValueService {
  private valueSubject = new Subject<number>();

  valueChanged$ = this.valueSubject.asObservable();

  emitValueChange(value: number): void {
    this.valueSubject.next(value);
  }
}
